module.exports = __webpack_public_path__ + "media/luxury-2026/original-city-living-960-fab3ba3b.jpg";